import React from "react";
import EpmsImage from "@/react/components/Common/EpmsImage";
import makeStyles from "@mui/styles/makeStyles";
import { formatCurrency } from "@/react/utils";
import Box from "@mui/material/Box";
const useStyles = makeStyles((theme) => ({
    container: {
        display: "flex",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
        },
    },
    pictureContainer: {
        display: "flex",
        "& img, & canvas": {
            maxWidth: "140px",
            display: "block",
            border: `2px solid ${theme.palette.primary.main}`,
        },
        marginRight: theme.spacing(2),
        [theme.breakpoints.down("sm")]: {
            marginBottom: theme.spacing(2),
            marginRight: 0,
            justifyContent: "center",
        },
    },
    subProductListContainer: {
        flexGrow: 1,
    },
    subProductList: {
        flexGrow: 1,
        listStyle: "none",
        padding: 0,
        margin: 0,
        "& > li": {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
        "& > li > label": {
            display: "flex",
        },
        "& > li input": {
            marginRight: theme.spacing(2),
        },
        paddingBottom: theme.spacing(2),
        [theme.breakpoints.down("sm")]: {
            borderBottom: `1px solid #707070`,
        },
    },
}));
const PictureListItem = ({ pictureUuid, product, pictureSubProducts, handleToggleSubProduct, }) => {
    var _a;
    const classes = useStyles();
    return (React.createElement("div", { className: classes.container },
        React.createElement("div", { className: classes.pictureContainer },
            React.createElement("div", null,
                React.createElement(EpmsImage, { uuid: pictureUuid, size: 320 }))),
        React.createElement("div", { className: classes.subProductListContainer },
            React.createElement("ul", { className: classes.subProductList }, ((_a = product.subproducts) !== null && _a !== void 0 ? _a : []).map((subProduct) => {
                console.log("Sub product", subProduct);
                return (React.createElement("li", { key: subProduct.uuid },
                    React.createElement("label", null,
                        React.createElement("input", { type: "checkbox", onClick: () => handleToggleSubProduct(subProduct.uuid), checked: pictureSubProducts.includes(subProduct.uuid) }),
                        " ",
                        React.createElement(Box, { flexGrow: 1 }, subProduct.name),
                        React.createElement("div", null, formatCurrency(subProduct.extraprice)))));
            })))));
};
export default PictureListItem;
